import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ServiceplanrateComponent } from './serviceplanrate.component';

const routes: Routes = [ { path: '', component: ServiceplanrateComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ServiceplanRateRoutingModule { }
